import { defineMessages } from 'react-intl';

export const scope = 'app.containers.Header';

export default defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: 'FOR INSURANCE AND FINANCIAL PROFESSIONAL USE ONLY - NOT FOR USE WITH OR DISTRIBUTION TO THE PUBLIC',
  },
  description: {
    id: `${scope}.description`,
    defaultMessage: '<p>The hypothetical returns shown in this calculator do not include the deduction of fees or charges that may be associated with a specific product. No representation is made that an FIA will achieve results similar to the calculated returns; actual product performance will differ materially from what is shown here.</p><p>This information is not intended as a recommendation to buy, hold, or sell any product or strategy or as a guarantee or estimate of future performance.</p><p>This tool was created by Annexus and is not intended to be relied upon as a forecast, research, or investment advice, and is not a recommendation, offer or solicitation to buy or sell any annuities.</p>',
  },
});